import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, BadgeCheck, Award, Users, Building2, PhoneCall } from "lucide-react";
import { STATS, HERO_IMAGES } from "../data/mock";

const Hero = () => {
  return (
    <section className="relative overflow-hidden lis-gradient-soft">
      <div className="absolute inset-0 grid-bg opacity-70" />
      <div className="hero-shine" />
      <div className="lis-container relative pt-14 pb-20 lg:pt-20 lg:pb-28 grid lg:grid-cols-2 gap-12 items-center">
        <div className="fade-in-up">
          <span className="chip">
            <span className="badge-dot" /> ISO Consulting  Training  Certification
          </span>
          <h1 className="mt-5 text-4xl md:text-5xl lg:text-6xl font-extrabold leading-[1.05] text-slate-900">
            Your trusted partner for
            <span className="text-brand"> ISO certification</span> and management systems
          </h1>
          <p className="mt-5 text-lg text-slate-600 max-w-xl">
            From gap analysis and documentation to internal audits and certification support   we help you implement world-class management systems that actually work on the ground.
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            <Link to="/contact" className="btn-brand">
              Book a Free Consultation <ArrowRight size={16} />
            </Link>
            <Link to="/services" className="btn-outline">
              Explore Services
            </Link>
            <a href="tel:+917982810821" className="hidden md:inline-flex items-center gap-2 text-sm font-semibold text-slate-700 hover:text-brand ml-2">
              <PhoneCall size={16} className="text-brand" /> +91 79828 10821
            </a>
          </div>

          <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-4 max-w-2xl">
            {STATS.map((s) => (
              <div key={s.label} className="stat-card">
                <div className="text-2xl font-extrabold text-brand">{s.value}</div>
                <div className="text-xs text-slate-500 mt-1">{s.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="relative fade-in-up" style={{ animationDelay: "120ms" }}>
          <div className="relative rounded-2xl overflow-hidden shadow-[0_30px_60px_-20px_rgba(15,23,42,0.25)]">
            <img src={HERO_IMAGES[0]} alt="ISO consulting team" className="w-full h-[420px] object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900/40 via-transparent to-transparent" />
          </div>

          {/* Floating badges */}
          <div className="absolute -left-4 top-8 bg-white rounded-xl shadow-xl p-4 float-anim border border-slate-100">
            <div className="flex items-center gap-3">
              <div className="w-11 h-11 rounded-full bg-red-50 text-brand flex items-center justify-center">
                <BadgeCheck size={22} />
              </div>
              <div>
                <div className="text-xs text-slate-500">Accredited</div>
                <div className="font-semibold text-slate-900 text-sm">IAF  UKAS  NABCB</div>
              </div>
            </div>
          </div>

          <div className="absolute -right-4 bottom-8 bg-white rounded-xl shadow-xl p-4 float-anim border border-slate-100" style={{ animationDelay: "1.2s" }}>
            <div className="flex items-center gap-3">
              <div className="w-11 h-11 rounded-full bg-red-50 text-brand flex items-center justify-center">
                <Award size={22} />
              </div>
              <div>
                <div className="text-xs text-slate-500">Success Rate</div>
                <div className="font-semibold text-slate-900 text-sm">99.6% certification pass</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
